module.exports = __webpack_public_path__ + "static/media/icon_newUser.5199995a.svg";